import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

// Only initialize Mixpanel if token is provided
if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV === "development"
  });
}

const trackEvent = (name: string, props?: object) => {
  // Skip tracking if Mixpanel is not configured
  if (!MIXPANEL_TOKEN) {
    return;
  }
  return mixpanel.track(name, props);
};

export default trackEvent;
